import React, { Component } from 'react'
import { connect } from 'react-redux'
// import { withRouter } from "react-router";
import { Redirect } from 'react-router-dom'
// import firebase from "firebase";
import VerifyEmail from '../layout/VerifyEmail';
import M from 'materialize-css';
M.AutoInit();

class HasTemplate extends Component {
	componentDidMount() {
		window.scrollTo(0, 0)
	}
	state = {
		hastemplate: '',
	}


	handleChange = (e) => {
		this.setState({
			[e.target.id]: e.target.value
		})
	}

	handleSubmit = (e) => {
		e.preventDefault();
		const hastemplate = this.state.hastemplate;
		if (hastemplate === "0") {
			this.props.history.push('/create')
		} else if (hastemplate === "1") {
			this.props.history.push('/newtemplate')
		}

	}
	render() {

		const { auth, profile } = this.props


		if (!auth.uid) {
			return <Redirect to={'/signin'} />
		} else if (auth.uid && !profile.esign && profile.isLoaded) {
			return <Redirect to={'/mysign'} />
		}
		if ((profile.createCount > 3) && ((profile.plan === null) || (!('plan' in profile)))) {
			return <Redirect to={'/upgrade'} />
		} else if (profile.createCount > 10 && (parseInt(profile.plan, 10) !== 2)) {
			return <Redirect to={'/upgrade'} />
		}

		if (auth.emailVerified) {
			return (
				<div className="grey lighten-5">
					<div className="container">
						<div className="row"></div>
						<form onSubmit={this.handleSubmit} className="white">
							<h5 className="grey-text text-darken-3">Create New NDA</h5>


							<div className="input-field">
								<select className="browser-default" onChange={this.handleChange} id="hastemplate">
									<option value="" disabled selected>Do you have your own NDA template?</option>
									<option value="0">Yes, I have my own template to use</option>
									<option value="1">No, I like to create one</option>
								</select>
								{/* <label htmlFor="hastemplate">Do you have your own NDA template?</label> */}
							</div>

							<div className="input-field">
								<button className="btn teal waves-effect waves-light lighten-1 z-depth-0" >NEXT</button>
							</div>
						</form>
						<div className="row"></div>
					</div>
					<div className="row"></div>
					<div className="row"></div>
					<div className="row"></div>
					<div className="row"></div>
					<div className="row"></div>
					<div className="row"></div>
					<div className="row"></div>
					<div className="row"></div>
					<div className="row"></div>
					<div className="row"></div>
					<div className="row"></div>
					<div className="row"></div>
					<div className="row"></div>
					<div className="row"></div>
					<div className="row"></div>
				</div>

			)

		} else if (auth && !auth.emailVerified) {
			return (
				<VerifyEmail auth={auth} />
			)
		}

	}
}

const mapStateToProps = (state) => {
	return {
		auth: state.firebase.auth,
		profile: state.firebase.profile
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		HasTemplate: (project) => dispatch(HasTemplate(project))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(HasTemplate);